import { WithMarginProp } from "@/src/styles/withMargin";
import { NavLink, match, useLocation } from "react-router-dom";
import { classNames } from "@/src/utils/cn";

const Link = ({
  children,
  size,
  onClick,
  mode,
  isActive,
  iconActiveColor,
  iconInactiveColor,
  ...props
}: {
  children:
    | React.ReactNode
    | (({
        isActive,
        iconActiveColor,
        iconInactiveColor,
      }: {
        isActive: boolean;
        iconActiveColor?: string;
        iconInactiveColor?: string;
      }) => React.ReactNode);
  size?: string;
  mode?: "secondary" | "primary";
  onClick?: () => void;
  isActive?<Params extends { [K in keyof Params]?: string }>(
    match: match<Params> | null,
    location: any,
  ): boolean;
  iconActiveColor?: string;
  iconInactiveColor?: string;
} & WithMarginProp & {
    to: string;
    exact?: boolean;
  }) => {
  const location = useLocation();

  // Determine if the link is active using the custom isActive function or default behavior
  const linkIsActive = isActive
    ? isActive(null, location)
    : props.exact
      ? location.pathname === props.to
      : location.pathname.startsWith(props.to);
  if (mode && mode === "secondary") {
    return (
      <NavLink
        isActive={isActive}
        {...props}
        onClick={onClick}
        key={props.to}
        className={(navLinkIsActive) => {
          return classNames(
            size === "s" ? "text-sm px-0" : "text-base",
            "gap-x-2 -mb-px py-1.5 my-1.5 text-concrete-700 font-semibold border-b-2 flex items-center",
            navLinkIsActive
              ? " text-concrete-900 border-concrete-900"
              : "text-concrete-600 opacity-70 hover:opacity-100 hover:border-persian-950 border-transparent",
          );
        }}
      >
        {typeof children === "function"
          ? children({
              isActive: linkIsActive,
              iconActiveColor,
              iconInactiveColor,
            })
          : children}
      </NavLink>
    );
  }

  return (
    <NavLink
      isActive={isActive}
      {...props}
      key={props.to}
      className={(navLinkIsActive) => {
        return classNames(
          size === "s" ? "text-sm px-0" : "text-base",
          "gap-x-2 px-3 py-1.5 my-1.5 hover:bg-persian-200 hover:text-persian-990 font-semibold rounded-md flex items-center",
          navLinkIsActive ? "bg-persian-950 text-white" : "text-persian-950",
        );
      }}
    >
      {typeof children === "function"
        ? children({
            isActive: linkIsActive,
            iconActiveColor,
            iconInactiveColor,
          })
        : children}
    </NavLink>
  );
};

export default Link;
